import { AlkLogger } from '@alk/core';
import { EConnectionState } from '../../enums';
import { injectable } from 'inversify';
import { ISessionLifecycle } from './session-lifecycle.interface';
import { NEVER, Observable, of } from 'rxjs';

@injectable()
export class SessionLifecycleServiceMock implements ISessionLifecycle {
    destroyObservable(): Observable<boolean> {
        return NEVER;
    }

    stop(): void {
        AlkLogger.debug('[SessionLifecycleServiceMock#stop]');
    }
    start(): Promise<void> {
        AlkLogger.debug('[SessionLifecycleServiceMock#start]');
        return Promise.resolve();
    }
    stateObservable(): Observable<EConnectionState> {
        return of('connected');
    }

}
